"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _styledComponents = require("styled-components");
var isCssVar = function isCssVar(s) {
  return s.substring(0, 2) === '--';
};
var testHexColor = new RegExp(/^#(?=[0-9A-F]*$)(?:.{3}|.{6})$/, 'i');
var useColor = function useColor(rawColor) {
  var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'transparent';
  if (!rawColor) return; // eslint-disable-next-line

  var theme = (0, _styledComponents.useTheme)(); // eslint-disable-next-line

  return (0, _react.useMemo)(function () {
    if (isCssVar(rawColor)) {
      return theme.color[rawColor.substring(2)] || defaultColor;
    }
    return testHexColor.test(rawColor) ? rawColor : defaultColor;
  }, [theme, rawColor, defaultColor]);
};
var _default = useColor;
exports["default"] = _default;